<template>
  <div class="page-container">
    <section>
      <Accounts @emitResult="next" />
    </section>
  </div>
</template>

<script>
import { redirectSignupManage } from '@/util/signupManage'
export default {
  components: { Accounts: () => import('@/components/account/AccountsHometax.vue') },
  async created() {
    _meta({
      titles: ['홈텍스계정연동'],
    })
  },
  methods: {
    async next() {
      //const next = this.$route.query.next || '/loan/pull-revenue';
      //this.$router.push(next);
      if( this.$route.query.next ) {
        return this.$router.replace(this.$route.query.next)
      }

      this.$router.push('/signup/agreements/kcs')
/*

      if (await redirectSignupManage()) {
        return
      }
      await this.$router.push({ name: 'factoring/confirm' })
      */
    },
  },
}
</script>
